import {  APP_PDC_URL } from "../../../config";

import { errorCodeMsg } from "../../../constants/errorUpload";
import { findVal } from "../../../libs/utils";
import { createHttpHeaderWithAuthorization } from "../../services/http-header";
import axios from "axios";

export const uploadConstants = {
  DOCUMENT_UPLOAD_START: "DOCUMENT_UPLOAD_START",
  DOCUMENT_UPLOAD_ERROR: "DOCUMENT_UPLOAD_ERROR",
  DOCUMENT_UPLOAD_SUCCESS: "DOCUMENT_UPLOAD_SUCCESS",
  DOCUMENT_UPLOAD_RESET: "DOCUMENT_UPLOAD_RESET",

  SINGLE_DOCUMENT_UPLOAD_SUCCESS: "SINGLE_DOCUMENT_UPLOAD_SUCCESS",
  SINGLE_DOCUMENT_UPLOAD_START: "SINGLE_DOCUMENT_UPLOAD_START",
  SINGLE_DOCUMENT_UPLOAD_ERROR: "SINGLE_DOCUMENT_UPLOAD_ERROR"
};

function getFileContent(file) {
  if (file.content && typeof file.content === "string") {
    return new Promise((resolve, reject) => {
      resolve(file.content);
    });
  } 
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.addEventListener(
      "load",
      function() {
        resolve(reader.result);
      },
      false
    );
    reader.readAsDataURL(file);
  });
  
}

const myUploadProgress = (currentFile, dispatch) => progressEvent => {
  if (progressEvent.lengthComputable) {
    currentFile.uploadPercentage = parseInt(Math.round((progressEvent.loaded * 100) / progressEvent.total));
    dispatch({
      type: uploadConstants.SINGLE_DOCUMENT_UPLOAD_START,
      payload: {
        fileName: currentFile.name,
        progress: currentFile.uploadPercentage
      }
    });
  }
};

export function uploadDocuments(
  sender,
  piva,
  files,
  categoryId,
  recipientId,
  note,
  metadata,
  codiceFiscale,
  source,
  encryptedOnUpload,
  userType,
  isVisibleByStudioOnly,
  accountable
) {
  return function(dispatch, getState) {

    const auth = getState().auth;

    dispatch({
      type: uploadConstants.DOCUMENT_UPLOAD_START
    });

    let config = {
      headers: createHttpHeaderWithAuthorization(auth.loginAuth.securityToken)
    };

    let errorsUpload = 0;
    let ids = [];
    let promiseArray = files.map(file => {
      return getFileContent(file).then(content => {
        dispatch({
          type: uploadConstants.SINGLE_DOCUMENT_UPLOAD_START,
          payload: { fileName: file.name }
        });
        let partitaIva = piva;
        /* TODO ristabilire quando si potranno caricare di nuovo gli archivi
         * const url = file.type === "application/zip" || file.type === "application/x-rar" ? API_PDC_URL_V1 + "documents/multi" : API_PDC_URL_V1 + "/documents";
         */
        const url = APP_PDC_URL + "/documents";
        config["onUploadProgress"] = myUploadProgress(file, dispatch);
        config["onDownloadProgress"] = myUploadProgress(file, dispatch);
        return axios
          .post(
            url,
            {
              recipientId: recipientId,
              senderId: sender,
              content: content,
              filename: file.name,
              partitaIva: partitaIva,
              codiceFiscale: codiceFiscale,
              source: source,
              metadata: metadata,
              note: note,
              categoryId: categoryId ? categoryId : 0,
              size: file.size,
              encryptedOnUpload: encryptedOnUpload,
              visibleByStudioOnly: isVisibleByStudioOnly,
              userType: userType,
              accountable: accountable
            },
            config
          )
          .then((result, error) => {
            if (result.status === 201 || result.status === 202) {
              ids.push(result.data.documentId);
              dispatch({
                type: uploadConstants.SINGLE_DOCUMENT_UPLOAD_SUCCESS,
                payload: {
                  fileName: file.name,
                  fileProgress: file.uploadPercentage,
                  filesIds: ids
                }
              });
            } else {
              errorsUpload++;
              dispatch({
                type: uploadConstants.SINGLE_DOCUMENT_UPLOAD_ERROR,
                payload: {
                  status: result.status,
                  fileName: file.name,
                  message: result.code && errorCodeMsg[result.code] ? errorCodeMsg[result.code] : "Si è verificato un errore durante caricamento del file"
                }
              });
            }
          })
          .catch(response => {                        
            /** quando entra in catch la chiamata in response restituisce un generico Network Error
             * e non ho modo di recuperare lo status code
             */
            let status = findVal(response, "status");
            let statusMessage = findVal(response, "message") ? findVal(response, "message") : findVal(response, "errorMessage");
            statusMessage = statusMessage ? statusMessage : "Si è verificato un errore durante caricamento del file";
            statusMessage = file.size > 16000000 ? "Dimensione del file troppo grande" : statusMessage;
            errorsUpload++;            
            dispatch({
              type: uploadConstants.SINGLE_DOCUMENT_UPLOAD_ERROR,
              payload: { fileName: file.name, message: statusMessage, status: status }
            });
          });
      });
    });
    return axios.all(promiseArray).then(result => {
      if (errorsUpload < 1) {
        dispatch({
          type: uploadConstants.DOCUMENT_UPLOAD_SUCCESS,
          payload: {
            filesIds: ids
          }
        });
      } else {
        // mi servono i documenti totali e gli errori per visualizzare un warning (alcui doc caricati) o un errore(nessun doc caricato)
        dispatch({
          type: uploadConstants.DOCUMENT_UPLOAD_ERROR,
          error: {
            numberFiles: files.length,
            errorFiles: errorsUpload
          }
        });
      }
    });
  };
}

export function resetUploadDocument() {
  return dispatch => {
    dispatch({
      type: uploadConstants.DOCUMENT_UPLOAD_RESET
    });
  };
}
